__turbopack_context__.v({
  "removeTagBtnStyles": "eDbFGa_removeTagBtnStyles",
  "tagListContainer": "eDbFGa_tagListContainer",
  "tagListContainerInner": "eDbFGa_tagListContainerInner",
  "tagName": "eDbFGa_tagName",
  "tagStyles": "eDbFGa_tagStyles",
  "tagWrapper": "eDbFGa_tagWrapper",
  "videoTagStaticText": "eDbFGa_videoTagStaticText",
  "videoTagVerticalLine": "eDbFGa_videoTagVerticalLine",
});
